import { render } from "./ArtSkuImport.vue?vue&type=template&id=5151a9c4"
import script from "./ArtSkuImport.vue?vue&type=script&lang=js"
export * from "./ArtSkuImport.vue?vue&type=script&lang=js"

import "./ArtSkuImport.vue?vue&type=style&index=0&id=5151a9c4&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__